module.exports = __webpack_public_path__ + "static/img/address-location.a9a29be4.gif";